import APIRequestService from './APIRequestService';

const request = new APIRequestService();

const minTwoDigits = (n) => {
  return (n < 10 ? '0' : '') + n;
};

const convertDate = (givenDate, dateType) => {
  const dateObj = new Date(givenDate);
  const _d = dateObj.getDate();
  const _y = dateObj.getFullYear();
  const _m = +(dateObj.getMonth()) + 1;
  const append = dateType === 'start' ? '00:00:00' : '23:59:59';
  /* eslint-disable-next-line */
  return _y + '-' + minTwoDigits(_m) + '-' + minTwoDigits(_d) + 'T' + append + '.000Z';
};

export const getLineupsList = async ({ selectedClient }) => {
  const url = `/fiduciaryclients/${selectedClient}/lineups`;
  return request.get(url);
};

export const getProductLineupsList = async ({ selectedClient, productId }) => {
  const url = `/fiduciaryclients/${selectedClient}/product/${productId}/lineups`;
  return request.get(url);
};

export const getLineupChangesList = async ({ selectedClient, dateFilter, axiosCancelToken }) => {
  let appendQuery = '';
  if (dateFilter?.startDate && dateFilter?.endDate) {
    const startDate = convertDate(dateFilter.startDate, 'start');
    const endDate = convertDate(dateFilter.endDate, 'end');
    appendQuery = `?startdate=${startDate}&enddate=${endDate}`;
  }
  const url = `/fiduciaryclients/${selectedClient}/lineups-changes${appendQuery}`;
  return request.get(url, {}, axiosCancelToken);
};

export const lineupUndoChanges = async ({ fiduciaryId, payload }) => {
  const url = `/fiduciaries/${fiduciaryId}/lineups/undo`;
  return request.post(url, { data: JSON.stringify(payload) });
};

export const submitFiduciaryLineupsChanges = async ({ fiduciary, payload }) => {
  const url = `/fiduciaries/${fiduciary}/lineups/submit`;
  return request.post(url, { data: JSON.stringify(payload) });
};

export const validateLineupsFile = async ({
  file,
}) => {
  const url = '/lineups/validate-file';
  const options = {
    config: {
      headers: {
        'content-type': 'multipart/form-data',
      },
    },
  };

  const formData = new FormData();
  formData.append('file', file);

  return request.uploadFile(url, formData, options);
};

export const importLineups = ({
  payload,
}) => {
  const url = '/lineups/batch-save';
  return request.post(url, { data: JSON.stringify(payload) });
};
